import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { IHeaderParams } from '@ag-grid-community/core';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

export interface AgExpenseDefaultGroupHeaderComponentParams extends IHeaderParams {
  headerPage: string;
  template: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TooltipDirective, IconComponent],
  styles: [
    `
      :host {
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100%;
      }
    `,
  ],
  template: `
    <div
      class="justify-left flex items-center space-x-[10px]"
      [ngClass]="{
        '-mt-[48px]': params.headerPage === 'budget',
        '-mt-[40px]': params.headerPage === 'quarter-close',
      }"
    >
      <div class="flex items-center justify-center space-x-[5px]">
        <button (click)="toggleExpand(false)">
          <span [auxTooltip]="'Expand All Rows'">
            <aux-icon name="ChevronsDown" />
          </span>
        </button>

        <button (click)="toggleExpand(true)">
          <span [auxTooltip]="'Collapse All Rows'">
            <aux-icon name="ChevronsUp" />
          </span>
        </button>
      </div>
      <div class="text-base text-aux-black" [innerHTML]="params.template"></div>
    </div>
  `,
})
export class AgExpenseDefaultGroupHeaderComponent implements IHeaderAngularComp {
  params!: AgExpenseDefaultGroupHeaderComponentParams;

  agInit(params: AgExpenseDefaultGroupHeaderComponentParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  toggleExpand(isExpanded: boolean) {
    if (isExpanded) {
      this.params.api.forEachNode((node) => {
        node.expanded = false;
      });
      this.params.api.onGroupExpandedOrCollapsed();
    } else {
      this.params.api.forEachNode((node) => {
        node.expanded = true;
      });
      this.params.api.onGroupExpandedOrCollapsed();
    }
  }
}
